import { MediaTrackerFn } from '@rhg/hooks/use-media-tracker/types';
import { SxProps, Theme } from '@rhg/libs/material';
import { ReactNode } from 'react';
import { PlayerAudio } from '../types';
import { ControlButtonType } from '../video-player/types';

export enum AudioPlayerControls {
    Regular = 'regular',
    Playlist = 'playlist',
    SingleLoopable = 'singleLoopable',
    Soundscape = 'soundscape',
    Infinite = 'infinite',
    MusicAlbum = 'musicAlbum',
    MusicSingle = 'musicSingle',
}

export enum AudioPlayerVariant {
    Expanded = 'expanded',
    Collapsed = 'collapsed',
    Minimal = 'minimal',
}

export enum AudioTimelineVariant {
    Large = 'large',
    Small = 'small',
    Minimal = 'minimal',
}

export interface AudioPlayerProps {
    audio: PlayerAudio;
    title?: string;
    subtitle?: string;
    image?: ReactNode;
    controls?: AudioPlayerControls;
    supportsPlaybackSpeed?: boolean;
    variant?: AudioPlayerVariant;
    customAction?: ReactNode;
    /** Shows Add to playlist in the expanded bottom row between playback speed and mute. */
    supportsAddToPlaylist?: boolean;
    onAddToPlaylist?: () => void;
    drawerTitleIcon?: ReactNode;
    autoplay?: boolean;
    loop?: boolean;
    previousProgress?: number;
    isInitiallyMuted?: boolean;
    isFloating?: boolean;
    willTrackProgress?: boolean;
    trackFn?: MediaTrackerFn;
    onClose?: () => void;
    controlsSx?: SxProps<Theme>;
    sx?: SxProps<Theme>;
    onNextTrack?: () => void;
    onPreviousTrack?: () => void;
    areControlsHidden?: boolean;
    onControlClick?: (buttonType: ControlButtonType) => void;
    onPlaybackMenuOpenChange?: (isOpen: boolean) => void;
}

export interface AudioControlsProps {
    controls?: AudioPlayerControls;
    supportsPlaybackSpeed?: boolean;
    variant?: Exclude<AudioPlayerVariant, AudioPlayerVariant.Minimal>;
    isFloating?: boolean;
    title?: string;
    subtitle?: string;
    image?: ReactNode;
    customAction?: ReactNode;
    /** Shows Add to playlist in the expanded bottom row between playback speed and mute. */
    supportsAddToPlaylist?: boolean;
    onAddToPlaylist?: () => void;
    onStop?: () => void;
    controlsSx?: SxProps<Theme>;
    sx?: SxProps<Theme>;
    onNextTrack?: () => void;
    onPreviousTrack?: () => void;
    areControlsHidden?: boolean;
    onControlClick?: (buttonType: ControlButtonType) => void;
    drawerTitleIcon?: ReactNode;
    onPlaybackMenuOpenChange?: (isOpen: boolean) => void;
}

export interface AudioMinimalControlsProps {
    onStop?: () => void;
    title?: string;
    subtitle?: string;
    image?: ReactNode;
    isFloating?: boolean;
    controlsSx?: SxProps<Theme>;
    sx?: SxProps<Theme>;
    controls?: AudioPlayerControls;
    areControlsHidden?: boolean;
    onControlClick?: (buttonType: ControlButtonType) => void;
}
